module.exports = __webpack_public_path__ + "static/media/ic_facebook.1da19b3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/share-fb-twitter/ic_facebook.svg
// module id = 218
// module chunks = 0